<template>
    <div class="tiny-block-component">
        <v-tooltip v-if="tooltip" bottom>
            <template #activator="{ on, attrs }">
                <v-card
                    class="tiny-block-card"
                    :elevation="elevation"
                    :class="cardClasses"
                    v-on="on"
                    v-bind="attrs"
                    @click="handleClick"
                >
                    <slot></slot>
                </v-card>
            </template>
            <span v-html="formattedTooltip"></span>
        </v-tooltip>
        <v-card
            v-else
            class="tiny-block-card"
            :elevation="elevation"
            :class="cardClasses"
            @click="handleClick"
        >
            <slot></slot>
        </v-card>
    </div>
</template>

<script>
import GlobalMixins from "@/mixins/global";

export default {
    name: "TinyBlock",
    mixins: [GlobalMixins],
    props: {
        elevation: {
            type: [String, Number],
            default: 0,
        },
        tooltip: {
            type: String,
            default: null,
            required: false,
        },
    },
    methods: {
        handleClick(event) {
            this.$emit("click", event);
        },
    },
    computed: {
        cardClasses() {
            return {
                "tiny-block-card--clickable": this.$listeners.click,
            };
        },
        formattedTooltip() {
            if (!this.tooltip) {
                return "";
            }
            return this.tooltip.replace(/\n/g, "<br />");
        },
    },
};
</script>

<style scoped lang="scss">
.tiny-block-component {
    width: 100%;
    flex-grow: 1;
}

.tiny-block-card {
    height: 100%;
    display: flex;
    flex-direction: column;

    &--clickable {
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            transform: translateY(-2px);
        }
    }
}
</style>
